// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","personalDetailsFormColumn":"_3n7-twZhcYGzFPd3Wp9pwT"};